import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db4502f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "input-container"
}
const _hoisted_2 = { class: "input-fieldset" }
const _hoisted_3 = { for: "fpwd-email" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_9 = {
  key: 1,
  class: "input-container"
}
const _hoisted_10 = { class: "infotext" }
const _hoisted_11 = { class: "code-fieldset" }
const _hoisted_12 = { for: "fpwd-code" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "input-fieldset" }
const _hoisted_17 = { for: "newpwd" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "input-fieldset" }
const _hoisted_22 = { for: "newpwd-re" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { style: {"margin-block-end":"0.2em"} }

import { ref } from "vue";
import { translate } from "@/util/intl";
import { CognitoService } from "@/backend/cognito";
import {index} from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordForgotten',
  emits: ['reseted'],
  setup(__props, { emit: __emit }) {

const cognito = new CognitoService();

const emit = __emit;

// data refs
const email = ref("");
const newpwd = ref("");
const newpwdRe = ref("");
const code = ref("");
// state refs
const resetRequestSuccessful = ref(false);
const inProcess = ref(false);
const isValidEmail =ref(true);
const isValidPassword = ref(true);
const passwordsMatch = ref(true);
const problemInitiating = ref(false);
const noCodeReceived = ref(false);
const wrongCode = ref(false);
const recentlySent = ref(false);

function resetFailStates() {
  problemInitiating.value = false;
  isValidEmail.value = true;
  isValidPassword.value = true;
  passwordsMatch.value = true;
  wrongCode.value = false;
}

// Cognito doesn't have code resend so we have to call the same function again to "resend"
function resendCode(): void {
  if (!recentlySent.value) {
    recentlySent.value = true;
    initiatePasswordReset();
    setTimeout(() => {
      recentlySent.value = false;
    }, 8000);
  }
}

// Step 1
// sets Cognito user state such that reset is possible and sends reset code to email
function initiatePasswordReset(): void {
  resetFailStates();
  const givenEmail = email.value.trim();
  if (!cognito.validateEmail(givenEmail)) {
    isValidEmail.value = false;
    return;
  }
  inProcess.value = true;
  cognito.resetPassword(givenEmail)
  .then(() => {
    index.commit("SET_USER_COGNITO_ID", givenEmail)
    resetRequestSuccessful.value = true;
    setTimeout(() => {
      noCodeReceived.value = true;
    }, 8000);
  }, err => {
    console.error(err.message);
    problemInitiating.value = true;
  })
  .finally(() => {
    inProcess.value = false;
  });
}

// Step 2
// user sends back code with a desired new password
function verifyAndResetPassword(): void {
  resetFailStates();
  const givenPwd = newpwd.value.trim();
  const rePwd = newpwdRe.value.trim();
  if (!cognito.validatePassword(givenPwd)) {
    isValidPassword.value = false;
    return;
  }
  if (givenPwd !== rePwd) {
    passwordsMatch.value = false;
    return;
  }
  if (isValidPassword.value && passwordsMatch.value) {
    inProcess.value = true;
    cognito.confirmNewPassword(code.value, givenPwd)
    .then(() => {
      emit('reseted');
    }, err => {
      wrongCode.value = true;
      console.error(err);
    })
    .finally(() => inProcess.value = false);
  }
}

return (_ctx: any,_cache: any) => {
  return (!resetRequestSuccessful.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref(translate)("give-email-password-reset")), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(translate)("email")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "fpwd-email",
            type: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            onKeyup: _withKeys(initiatePasswordReset, ["enter"]),
            disabled: inProcess.value,
            autofocus: ""
          }, null, 40, _hoisted_4), [
            [_vModelText, email.value]
          ]),
          (!isValidEmail.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(translate)("invalid-email")), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_6))
        ]),
        _createElementVNode("button", {
          class: "buttonContinue",
          onClick: initiatePasswordReset,
          disabled: inProcess.value
        }, _toDisplayString(_unref(translate)("generic-continue")), 9, _hoisted_7),
        (problemInitiating.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(translate)("payment-error-unknown-text")), 1))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(translate)("password-reset-guide")), 1),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)("auth-code")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "fpwd-code",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((code).value = $event)),
            disabled: inProcess.value
          }, null, 8, _hoisted_13), [
            [_vModelText, code.value]
          ]),
          (wrongCode.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(translate)("faulty-mfa-code")), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_15))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(translate)("give-new-password")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "newpwd",
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newpwd).value = $event)),
            onKeyup: _withKeys(verifyAndResetPassword, ["enter"]),
            disabled: inProcess.value,
            autofocus: ""
          }, null, 40, _hoisted_18), [
            [_vModelText, newpwd.value]
          ]),
          (!isValidPassword.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(translate)("give-password")), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_20))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(translate)("password-re")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "newpwd-re",
            type: "password",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newpwdRe).value = $event)),
            onKeyup: _withKeys(verifyAndResetPassword, ["enter"]),
            disabled: inProcess.value
          }, null, 40, _hoisted_23), [
            [_vModelText, newpwdRe.value]
          ]),
          (!passwordsMatch.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_unref(translate)("password-mismatch")), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_25))
        ]),
        _createElementVNode("button", {
          class: "buttonContinue",
          onClick: verifyAndResetPassword
        }, _toDisplayString(_unref(translate)("reset-password")), 1),
        (noCodeReceived.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(translate)("check-junkmail")), 1),
              _createElementVNode("a", {
                class: "alink",
                href: "#",
                onClick: resendCode
              }, _toDisplayString(_unref(translate)("no-code-received-q")), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})